import Vue from 'vue';

import CommonSelect from '@/components/common/CommonSelect';
import CommonSelectMultiple from '@/components/common/CommonSelectMultiple';
import CommonSelectDateTime from '@/components/common/CommonSelectDateTime';
import CommonSelectSearch from '@/components/common/CommonSelectSearch';
import CommonTooltip from '@/components/common/CommonTooltip';

Vue.component("common-select", CommonSelect);
Vue.component("common-select-multiple", CommonSelectMultiple);
Vue.component("common-select-datetime", CommonSelectDateTime);
Vue.component("common-select-search", CommonSelectSearch);
Vue.component("common-tooltip", CommonTooltip);




// WEBPACK FOOTER //
// ./src/util/globalComponents.js